import { render, staticRenderFns } from "./BlockDataList.vue?vue&type=template&id=57aec6ee&"
import script from "./BlockDataList.vue?vue&type=script&lang=js&"
export * from "./BlockDataList.vue?vue&type=script&lang=js&"
import style0 from "./BlockDataList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports